import {
  ReceiptRecoveryStats,
  ReceiptWorkGroup,
} from 'src/feature/ReceiptRecovery/receiptRecovery.types'
import { AccountingPeriod } from 'src/queries/organizations/accountingPeriods/accountingPeriods.models'

export const RECEIPT_RECOVERY_MOCK_ACCOUNTING_PERIODS = [
  {
    id: 'mock-april-2026',
    label: 'April 2026',
    localStartDate: '2026-04-01',
    localEndDate: '2026-05-01',
    startsAt: '2026-04-01T04:00:00.000Z',
    endsAt: '2026-05-01T04:00:00.000Z',
    timezone: 'America/New_York',
    current: true,
    summary: 'In view · 315 open',
  },
  {
    id: 'mock-may-2026',
    label: 'May 2026',
    localStartDate: '2026-05-01',
    localEndDate: '2026-06-01',
    startsAt: '2026-05-01T04:00:00.000Z',
    endsAt: '2026-06-01T04:00:00.000Z',
    timezone: 'America/New_York',
    current: false,
    summary: '38 open',
  },
  {
    id: 'mock-march-2026',
    label: 'March 2026',
    localStartDate: '2026-03-01',
    localEndDate: '2026-04-01',
    startsAt: '2026-03-01T05:00:00.000Z',
    endsAt: '2026-04-01T04:00:00.000Z',
    timezone: 'America/New_York',
    current: false,
    summary: '0 open · 218 reconciled',
  },
] as const satisfies readonly AccountingPeriod[]

export const RECEIPT_RECOVERY_MOCK_STATS_BY_PERIOD: Readonly<
  Record<string, ReceiptRecoveryStats>
> = {
  'mock-april-2026': {
    needsReview: 48,
    waitingOnSpender: 267,
    receiptReconciled: 176,
  },
  'mock-may-2026': {
    needsReview: 12,
    waitingOnSpender: 26,
    receiptReconciled: 0,
  },
  'mock-march-2026': {
    needsReview: 0,
    waitingOnSpender: 0,
    receiptReconciled: 218,
  },
}

export const RECEIPT_WORK_GROUPS = [
  {
    state: 'needs-review',
    total: 48,
    items: [
      {
        id: 'acme-hotel',
        merchant: 'ACME Hotel',
        amount: '$486.20',
        cardLastFour: '4417',
        date: 'Apr 24',
      },
      {
        id: 'delta-airlines',
        merchant: 'Delta Airlines',
        amount: '$312.40',
        cardLastFour: '2286',
        date: 'Apr 26',
      },
      {
        id: 'hilton-garden-inn',
        merchant: 'Hilton Garden Inn',
        amount: '$1,204.75',
        cardLastFour: '4417',
        date: 'Apr 27',
      },
      {
        id: 'figma',
        merchant: 'Figma',
        amount: '$48.00',
        cardLastFour: '9013',
        date: 'Apr 29',
      },
    ],
  },
  {
    state: 'waiting-on-spender',
    total: 267,
    items: [
      {
        id: 'adobe',
        merchant: 'Adobe',
        amount: '$240.00',
        cardLastFour: '9013',
        date: 'Apr 22',
        reminderDate: 'Apr 27',
      },
      {
        id: 'verizon',
        merchant: 'Verizon',
        amount: '$149.82',
        cardLastFour: '4417',
        date: 'Apr 24',
      },
      {
        id: 'lyft',
        merchant: 'Lyft',
        amount: '$41.50',
        cardLastFour: '2286',
        date: 'Apr 28',
      },
    ],
  },
  {
    state: 'receipt-reconciled',
    total: 176,
    items: [
      {
        id: 'google-ads',
        merchant: 'Google Ads',
        amount: '$401.63',
        cardLastFour: '9013',
        date: 'Apr 26',
      },
      {
        id: 'jetblue',
        merchant: 'JetBlue',
        amount: '$258.79',
        cardLastFour: '2286',
        date: 'Apr 29',
      },
    ],
  },
] as const satisfies readonly ReceiptWorkGroup[]
